import React, { useEffect } from 'react';
import './ChannelInfoModal.css';
import defaultAlbumArt from '../images/default-album-art.png';

const ChannelInfoModal = ({ channel, onClose }) => {
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [onClose]);

  return (
    <div className="channel-info-modal-overlay" onClick={onClose}>
      <div className="channel-info-modal-content" onClick={e => e.stopPropagation()}>
        <button className="channel-info-modal-close" onClick={onClose}>×</button>
        
        <div className="channel-info-modal-header">
          <h2>Artwork</h2>
          <h2>Channel</h2>
          <h2>Description</h2>
        </div>
        
        <div className="channel-info-modal-body">
          <div className="channel-info-modal-artwork">
            <img 
              src={channel.image || defaultAlbumArt} 
              alt={channel.name}
            />
          </div>
          
          <div className="channel-info-modal-name">
            <h3>{channel.name}</h3>
            
            <div className="channel-info-modal-section">
              <h4>Genre(s)</h4>
              <p>{channel.genre || 'Pop, Hip-Hop, R&B, Rap, EDM, Country, Rock, Jazz, Blues, Funk, Soul, Reggae, Latin,'}</p>
            </div>
            
            <div className="channel-info-modal-section">
              <h4>Featured Artists</h4>
              <p>{channel.featuredArtists || '50 Cent, Avril Lavigne, Backstreet Boys, Britney Spears, Christina Aguilera, Coldplay, Eminem, Enrique Iglesias, Jay-Z, Jennifer Lopez, John Mayer, JoJo, Justin Timberlake, Kelly Clarkson, Leann Rimes, Lenny Kravitz, LFO, Ludacris, Maroon 5, Missy Elliott, Natasha Bedingfield, Nelly, Nelly Furtado, No Doubt, Nsync, O-Town, Outkast, Ricky Martin, Shaggy, Shakira'}</p>
            </div>
          </div>
          
          <div className="channel-info-modal-info">
            <h3 className="channel-info-modal-description">{channel.description || 'Hit Music From 2000 to 2010!'}</h3>
            
            <div className="channel-info-modal-section">
              <h4>Energy Level</h4>
              <p>{channel.energyLevel || 'Medium to high'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelInfoModal; 